export enum PriceSimulationFlow {
    "", "Product overzicht" = 'a', "Voorstel op maat" = 'b', "Verbruik invullen" = "c", "Simulatie starten" = "d" 
}